import { useEffect, useState } from "react";
import EditableTable from "../../Reusable/Table/EditableTable";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Tag, message, Input, Button, Form, Select, Modal, Popconfirm } from "antd";
import consts from "../../constant";
import { EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import Loadingpage from "../Loadingpage/Loadingpage";
const Adminmanage = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [formLayout] = useState("vertical");
  const [form] = Form.useForm();
  const [page, setPage] = useState({ current: 1, pageSize: 10 });
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openViewDrawer, setOpenViewDrawer] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("false");
  const [messageApi, contextHolder] = message.useMessage();
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [wallet, setWallet] = useState([]);
  const [filterVerified, setFilterVerified] = useState("");
  const [filter2fa, setFilter2fa] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [searchText, setSearchText] = useState("");
  const [searchTrigger, setSearchTrigger] = useState("");
  const [selectedAssets, setSelectedAssets] = useState(null);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [pairStatus, setPairStatus] = useState(null);


  const [status, setStatus] = useState("active");
  const { Search } = Input;

  const onClose = () => {
    setOpenDrawer(false);
    setSelectedUser(null);
    setOpenViewDrawer(false);
  };

  const [roleUser, setRoleUser] = useState([]);
  const [availableRoles, setAvailableRoles] = useState([]);

  const fetchSubAdmins = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${consts.BackendUrl}/get-admin`,
        {
          search: searchTrigger,
          status: pairStatus === "active" ? true : pairStatus === "inactive" ? false : undefined,
          page: page.current,
          limit: page.pageSize,
        },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );
      if (response.data.success) {
        const data = response.data.result.map((item, index) => ({
          ...item,
          key: item._id,
          sno: (page.current - 1) * page.pageSize + index + 1,
          rolename: item.name,
          role: item.access?._id || item.access, // Store role ID
          roleName: item.access?.name || "Sub Admin", // Handle if populated
          status: item.status ? "active" : "inactive",
        }));
        setRoleUser(data);
        setTotal(response.data.count || data.length);
      } else {
        message.warning(response.data.message);
        setRoleUser([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("Fetch Sub Admins Error:", error);
      messageApi.open({ type: "error", content: "Failed to fetch sub admins" });
    } finally {
      setLoading(false);
    }
  };

  const fetchRoles = async () => {
    try {
      const response = await axios.post(
        `${consts.BackendUrl}/get-roles`,
        { status: true },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );
      if (response.data.success) {
        const roles = response.data.result.map(role => ({
          label: role.name,
          value: role._id,
        }));
        setAvailableRoles(roles);
      }
    } catch (error) {
      console.error("Fetch Roles Error:", error);
    }
  };

  useEffect(() => {
    fetchSubAdmins();
    fetchRoles();
  }, [page.current, page.pageSize, searchTrigger, pairStatus]);

  const userColumns = [
    { title: "Sno", dataIndex: "sno", key: "sno" },

    {
      title: "  Name",
      dataIndex: "rolename",
      key: "rolename",
      searchable: true,
    },
    { title: "Email", dataIndex: "email", key: "email" },

    {
      title: "Role",
      dataIndex: "roleName", // Refer to the populated display name
      key: "role",
      render: (value) => {
        return value || "Sub Admin";
      },
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value) => {
        return value === "active" ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">In-Active</Tag>
        );
      },
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (value) => new Date(value).toLocaleDateString(),
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Button
          type="link"
          icon={<EditOutlined />}
          onClick={() => handleEditAsset(record)}
          style={{ color: "#2eff0c" }}
        >
          Edit
        </Button>
      ),
    },
  ];

  // Edit
  const handleEditAsset = (record) => {
    form.resetFields();
    setSelectedAssets(record);
    setIsFormChanged(false);
    setIsModalOpen(true);

    form.setFieldsValue({
      rolename: record.rolename,
      username: record.username,
      email: record.email,
      phone: record.phone,
      role: record.role, // role ID is stored here
      status: record.status,
    });
  };

  // multi select
  const sidebarItems = availableRoles;

  const showModal = () => {
    setLoading(true);

    setTimeout(() => {
      form.resetFields();
      setSelectedAssets(null);
      setIsFormChanged(true);
      setIsModalOpen(true);

      setLoading(false);
    }, 2000);
  };

  const handleDelete = async () => {
    if (!selectedAssets) return;
    setLoading(true);
    try {
      const response = await axios.post(
        `${consts.BackendUrl}/delete-admin`,
        { id: selectedAssets._id },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );
      if (response.data.success) {
        messageApi.open({ type: "success", content: "Sub admin deleted successfully!" });
        setIsModalOpen(false);
        fetchSubAdmins();
      } else {
        messageApi.open({ type: "error", content: response.data.message });
      }
    } catch (error) {
      console.error("Delete Sub Admin Error:", error);
      messageApi.open({ type: "error", content: error.response?.data?.message || "Failed to delete sub admin" });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("Submitted:", values);

        setIsModalOpen(false);
        form.resetFields();
      })
      .catch((err) => {
        console.log("Validation Failed:", err);
      });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedAssets(null);
    form.resetFields();
  };

  const handlePagination = (pagination) => {
    console.log("Table params:", pagination);
    setPage(pagination);
  };
  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        name: values.rolename,
        // username: values.username,
        email: values.email,
        // phone: values.phone,
        access: values.role,
        password: values.password,
        status: values.status === "active",
      };

      if (selectedAssets) {
        payload.id = selectedAssets._id;

        // Frontend validation: check if the new payload exactly matches the existing data
        const isIdentical =
          selectedAssets.rolename === values.rolename &&
          // selectedAssets.username === values.username &&
          selectedAssets.email === values.email &&
          // selectedAssets.phone === values.phone &&
          selectedAssets.role === values.role &&
          selectedAssets.status === values.status &&
          !values.password; // If no new password is submitted

        if (isIdentical) {
          messageApi.open({ type: "warning", content: "No changes detected" });
          setLoading(false);
          return;
        }
      }

      const response = await axios.post(
        `${consts.BackendUrl}/create-admin`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );

      if (response.data.success) {
        messageApi.open({
          type: "success",
          content: selectedAssets ? "Sub admin updated successfully!" : "Sub admin created successfully!"
        });
        setIsModalOpen(false);
        setSelectedAssets(null);
        form.resetFields();
        fetchSubAdmins();
      } else {
        messageApi.open({ type: "error", content: response.data.message });
      }
    } catch (error) {
      console.error("Submit Sub Admin Error:", error);
      messageApi.open({ type: "error", content: error.response?.data?.message || "Failed to submit sub admin" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="display-2 p-10">
        <h2>Admin Management</h2>
        <div className="display-2">
          <Search
            placeholder="Search for name"
            value={searchText}
            onChange={(e) => {
              const value = e.target.value;

              setSearchText(value);

              // clear icon click
              if (!value) {
                setSearchTrigger("");

                setPage({
                  current: 1,
                  pageSize: 10,
                });
              }
            }}
            onSearch={(value) => {
              setPage((prev) => ({
                ...prev,
                current: 1,
              }));

              setSearchTrigger(value);
            }}
            allowClear
            style={{ width: 200 }}
            loading={confirmLoading}
            className="input-cls"
          />

          <Select
            allowClear
            placeholder=" Status"
            value={pairStatus}
            style={{ width: 130, marginLeft: 10 }}
            onChange={(e) => {
              setPairStatus(e);
              setPage({ current: 1, pageSize: 10 });
            }}
          >
            <Select.Option value={"active"}>Active</Select.Option>
            <Select.Option value={"inactive"}>In Active</Select.Option>
          </Select>

          <Button
            onClick={() => {
              setSearchText("");
              setSearchTrigger("");
              setPairStatus(null);
              setPage({ current: 1, pageSize: 10 });
            }}
            style={{ marginLeft: 10 }}
          >
            Clear Filter
          </Button>

          <Button
            onClick={showModal}
            style={{ marginLeft: 10 }}
            icon={<PlusCircleOutlined />}
            loading={loading}
          >
            Create Sub Admin
          </Button>
        </div>
      </div>
      <EditableTable
        columnsConfig={userColumns}
        dataSource={roleUser}
        className="mt-20"
        total={total}
        pageSize={10}
        current={page?.current ? page?.current : 1}
        closeDisabled={true}
        onChange={handlePagination}
        loading={confirmLoading}
      />
      <Loadingpage isLoading={loading} />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Modal
          title="Create Sub Admin"
          open={isModalOpen}
          footer={null}
          // className="roleuser-modal "
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          maskStyle={{
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          }}
          styles={{
            content: {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(10px)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              color: "white",
            },
            header: {
              backgroundColor: "transparent",
            },
          }}
        >
          <Form
            form={form}
            layout="vertical"
            className="scroll-inmobile"
            onFinish={onFinish}
            onValuesChange={(_, allValues) => {
              if (!selectedAssets) {
                setIsFormChanged(true);
                return;
              }
              const isIdentical =
                selectedAssets.rolename === allValues.rolename &&
                // selectedAssets.username === allValues.username &&
                selectedAssets.email === allValues.email &&
                // selectedAssets.phone === allValues.phone &&
                selectedAssets.role === allValues.role &&
                selectedAssets.status === allValues.status &&
                !allValues.password;

              setIsFormChanged(!isIdentical);
            }}
          >
            <Form.Item
              label=" Name"
              name="rolename"
              rules={[
                { required: true, message: "Please Enter name" },
                { min: 3, message: "Minimum 3 characters" },
              ]}
            >
              <Input
                maxLength={30}
                placeholder="Enter Name"
                style={{ background: "transparent" }}
                autoComplete="off"
              />
            </Form.Item>
            {/* <Form.Item
              label="Username"
              name="username"
              rules={[
                { required: true, message: "Please Enter Username" },
                { min: 3, message: "Minimum 3 characters" },
              ]}
            >
              <Input
                placeholder="Enter Username"
                style={{ background: "transparent" }}
              />
            </Form.Item> */}
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Please Enter Email Id" }]}
            >
              <Input
                placeholder="Enter  Email Id"
                style={{ background: "transparent" }}
                autoComplete="new-password"
              />
            </Form.Item>
            {/* <Form.Item
              label="Phone"
              name="phone"
              rules={[{ required: true, message: "Please Enter Phone Number" }]}
            >
              <Input
                placeholder="Enter Phone Number"
                style={{ background: "transparent" }}
              />
            </Form.Item> */}
            <Form.Item
              label="Password"
              name="password"
              rules={[
                ({ }) => ({
                  validator(_, value) {
                    if (!selectedAssets && !value) {
                      return Promise.reject(new Error("Please enter password"));
                    }
                    if (value && value.length < 6) {
                      return Promise.reject(new Error("Minimum 6 characters"));
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input.Password
                maxLength={20}
                placeholder="Enter password"
                style={{ background: "transparent" }}
                autoComplete="new-password"
              />
            </Form.Item>
            <Form.Item
              label="Confirm Password"
              name="confirmPassword"
              dependencies={["password"]}
              rules={[
                {
                  required: !selectedAssets,
                  message: "Please confirm password",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const password = getFieldValue("password");

                    //  If password entered → confirm is required
                    if (password && !value) {
                      return Promise.reject(new Error("Please confirm password"));
                    }
                    //  If both exist but not match
                    if (value && password !== value) {
                      return Promise.reject(new Error("Passwords do not match"));
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input.Password
                maxLength={20}
                placeholder="Confirm password"
                style={{ background: "transparent" }}
                autoComplete="new-password"
              />
            </Form.Item>
            <Form.Item
              label="Status"
              name="status"
              rules={[{ required: true, message: "Please select status" }]}
            >
              <Select placeholder="Select status">
                <Select.Option value="active">Active</Select.Option>
                <Select.Option value="inactive">Inactive</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Roles"
              name="role"
              rules={[{ required: true, message: "Please select roles" }]}
            >
              <Select placeholder="Select roles" options={sidebarItems} />
            </Form.Item>
            <div className="display-2">
              <Form.Item>
                <Button
                  htmlType="submit"
                  loading={loading}
                  disabled={selectedAssets && !isFormChanged}
                  style={{
                    cursor: selectedAssets && !isFormChanged ? "not-allowed" : "pointer",
                  }}
                >
                  {selectedAssets ? "Edit" : "Create"}
                </Button>
              </Form.Item>

              {selectedAssets && (
                <Form.Item>
                  <Popconfirm
                    title={<span style={{ color: "white" }}>Delete the admin</span>}
                    description={<span style={{ color: "white" }}>Are you sure you want to delete this admin?</span>}
                    onConfirm={handleDelete}
                    okText="Yes"
                    cancelText="No"
                    overlayInnerStyle={{
                      backgroundColor: "#03321E",
                      border: "1px solid #2eff0c",
                    }}
                  >
                    <Button
                      type="primary"
                      htmlType="button"
                      loading={loading}
                      danger
                      className="delete-btn"
                    >
                      Delete
                    </Button>
                  </Popconfirm>
                </Form.Item>
              )}
            </div>
          </Form>
        </Modal>
      </div>
      {contextHolder}
    </>
  );
};

export default Adminmanage;
